import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorGuide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M6 2.25A3.75 3.75 0 0 0 2.25 6v13A2.75 2.75 0 0 0 5 21.75h12a.75.75 0 0 0 0-1.5H5a1.25 1.25 0 1 1 0-2.5h15A1.75 1.75 0 0 0 21.75 16V6A3.75 3.75 0 0 0 18 2.25H6Zm8.667 14H20a.25.25 0 0 0 .25-.25V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v10.55c.375-.192.8-.3 1.25-.3h9.667Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M10.204 7.62c.06-.163.512-.87 1.785-.87.307 0 .684.128 1.025.38.34.25.585.578.684.906.093.306.074.641-.165 1.003-.253.383-.788.845-1.826 1.266a.75.75 0 0 0 .564 1.39c1.203-.488 2.036-1.106 2.514-1.83.493-.747.567-1.548.348-2.265-.21-.694-.682-1.275-1.229-1.678-.546-.402-1.227-.672-1.915-.672-1.913 0-2.921 1.111-3.194 1.856a.75.75 0 1 0 1.41.515ZM12 14.45a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorGuide;
